import {
  FETCH_SECTIONS,
  FETCH_SECTIONS_SUCCESS,
  FETCH_SECTIONS_FAIL,
  FETCH_SECTION_TASKS,
  FETCH_SECTION_TASKS_SUCCESS,
  FETCH_SECTION_TASKS_FAIL,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_STATUS_SUCCESS,
  UPDATE_TASK_STATUS_FAIL,
  CLEAR_SECTIONS_CACHE,
  SET_ACTIVE_SECTION,
} from "./actionTypes"

const CACHE_DURATION = 60000 // 1 minute cache

const initialState = {
  sections: [],
  tasks: [],
  activeSection: null,
  loading: false,
  tasksLoading: false,
  updating: false,
  error: null,
  lastFetched: null,
  tasksLastFetched: null,
}

const sections = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SECTIONS:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case FETCH_SECTIONS_SUCCESS:
      return {
        ...state,
        sections: action.payload,
        loading: false,
        lastFetched: Date.now(),
        error: null,
      }

    case FETCH_SECTIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case FETCH_SECTION_TASKS:
      return {
        ...state,
        tasksLoading: true,
      }

    case FETCH_SECTION_TASKS_SUCCESS:
      return {
        ...state,
        tasks: action.payload,
        tasksLoading: false,
        tasksLastFetched: Date.now(),
      }

    case FETCH_SECTION_TASKS_FAIL:
      return {
        ...state,
        tasksLoading: false,
        error: action.payload,
      }

    case UPDATE_TASK_STATUS:
      return {
        ...state,
        updating: true,
      }

    case UPDATE_TASK_STATUS_SUCCESS:
      return {
        ...state,
        updating: false,
        tasks: state.tasks.map((t) =>
          t.id === action.payload.id ? { ...t, ...action.payload } : t
        ),
      }

    case UPDATE_TASK_STATUS_FAIL:
      return {
        ...state,
        updating: false,
        error: action.payload,
      }

    case CLEAR_SECTIONS_CACHE:
      return {
        ...state,
        lastFetched: null,
        tasksLastFetched: null,
      }

    case SET_ACTIVE_SECTION:
      return {
        ...state,
        activeSection: action.payload,
      }

    default:
      return state
  }
}

export default sections

// Selectors
export const selectSections = (state) => state.sections.sections
export const selectSectionTasks = (state) => state.sections.tasks
export const selectActiveSection = (state) => state.sections.activeSection
export const selectSectionsLoading = (state) => state.sections.loading
export const selectTasksLoading = (state) => state.sections.tasksLoading
export const selectUpdating = (state) => state.sections.updating

export const selectIsCacheValid = (state) => {
  const { lastFetched } = state.sections
  if (!lastFetched) return false
  return Date.now() - lastFetched < CACHE_DURATION
}

export const selectTasksCacheValid = (state) => {
  const { tasksLastFetched } = state.sections
  if (!tasksLastFetched) return false
  return Date.now() - tasksLastFetched < CACHE_DURATION
}

// Get tasks for a specific section
export const selectTasksBySection = (state, sectionName) => {
  if (!sectionName) return []
  return state.sections.tasks.filter((t) => t.type === sectionName)
}

// Get task counts by status for a section
export const selectSectionTaskStats = (state, sectionName) => {
  const tasks = selectTasksBySection(state, sectionName)
  return {
    total: tasks.length,
    pending: tasks.filter((t) => t.status === "PENDING").length,
    stockReceived: tasks.filter((t) => t.status === "STOCK-RECEIVED").length,
    finished: tasks.filter((t) => t.status === "FINISHED").length,
  }
}

// Get aggregated stats for all sections
export const selectAllSectionsStats = (state) => {
  const { sections, tasks } = state.sections
  return sections.map((section) => {
    const sectionTasks = tasks.filter((t) => t.type === section.name)
    return {
      ...section,
      totalTasks: sectionTasks.length,
      pendingTasks: sectionTasks.filter((t) => t.status === "PENDING").length,
      stockReceivedTasks: sectionTasks.filter((t) => t.status === "STOCK-RECEIVED").length,
      finishedTasks: sectionTasks.filter((t) => t.status === "FINISHED").length,
    }
  })
}
